import { useEffect, useRef } from "react";
import { toast } from "sonner";
import logo from "../../img/logo.jpeg";
import word from "../../img/word.jpg";
import excel from "../../img/excel.jpg";
import gmail from "../../img/gmail.jpeg";
import db from "../../img/base de datos.jpg";
import automatizacion from "../../img/automatitation.jpg";
import openapi from "../../img/openapi.jpg";
import pdf from "../../img/pdf.jpg";

export default function SignalGPT() {
  const shownRef = useRef(false);

  useEffect(() => {
    if (!shownRef.current) {
      toast("🚀 ¡SignalGPT llega pronto!", {
        description:
          "Estamos trabajando arduamente para brindarte esta interesante función.",
      });
      shownRef.current = true;
    }
  }, []);

  const integrations = [
    {
      id: 1,
      img: word,
      alt: "Word",
      name: "Word",
      color: "#EA4335",
    },
    {
      id: 2,
      img: automatizacion,
      alt: "Automatización",
      name: "Automatización",
      color: "#217346",
    },
    {
      id: 3,
      img: pdf,
      alt: "SQL Server",
      name: "SQL Server",
      color: "#CC2927",
    },
    {
      id: 4,
      img: openapi,
      alt: "GPT",
      name: "GPT",
      color: "#4A154B",
    },
    {
      id: 5,
      img: excel,
      alt: "Excel",
      name: "Excel",
      color: "#000000",
    },
    {
      id: 6,
      img: db,
      alt: "Base de datos",
      name: "Base de datos",
      color: "#FF4A00",
    },
    {
      id: 7,
      img: gmail,
      alt: "Gmail",
      name: "Gmail",
      color: "#FF7A59",
    },
  ];

  return (
    <>
      <section
        className="position-relative py-5 text-center"
      >
        <div className="container position-relative">
          {/* Título */}
          <h1 className="fw-bold display-3 mb-3">
            Optimiza tu gestión con<br /> inteligencia y automatización
          </h1>

          {/* Coming Soon Badge */}
          <div className="mb-4">
            <span 
              className="badge bg-primary px-3 py-2 rounded-pill"
              style={{
                fontSize: "1rem",
                background: "linear-gradient(45deg, #3b82f6, #1d4ed8)",
                boxShadow: "0 4px 15px rgba(59, 130, 246, 0.3)"
              }}
            >
              🚀 Proximamente
            </span>
          </div>

          {/* Descripción */}
          <p className="text-muted mb-5 mx-auto fs-7" style={{ maxWidth: "700px" }}>
            Consulta tu información en tiempo real, envía facturas, genera documentos y automatiza 
            procesos para agilizar cada tarea de tu negocio.
          </p>

          {/* Contenedor de integraciones */}
          <div
            className="position-relative mx-auto integration-container shadow-lg"
            style={{
              width: "100%",
              maxWidth: "700px",
              height: "400px",
              background: `
                radial-gradient(circle at center, rgba(122,90,248,0.05), transparent),
                repeating-linear-gradient(0deg, transparent, transparent 20px, rgba(122,90,248,0.02) 20px, rgba(122,90,248,0.02) 22px),
                repeating-linear-gradient(90deg, transparent, transparent 20px, rgba(122,90,248,0.02) 20px, rgba(122,90,248,0.02) 22px),
                repeating-linear-gradient(45deg, transparent, transparent 30px, rgba(122,90,248,0.01) 30px, rgba(122,90,248,0.01) 32px)
              `,
              borderRadius: "25px",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 20px 40px rgba(122,90,248,0.15), 0 10px 20px rgba(0,0,0,0.1)"
            }}
          >
            {/* Ícono central */}
            <div
              className="position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center rounded-circle shadow-sm central-icon"
              style={{
                width: "100px",
                height: "100px",
                background: "white",
                border: "3px solid #3b82f6",
                zIndex: 3,
                boxShadow: "0 0 20px rgba(59, 130, 246, 0.6), 0 0 40px rgba(59, 130, 246, 0.4), 0 0 60px rgba(59, 130, 246, 0.2)",
                animation: "pulse-glow 2s ease-in-out infinite alternate, vibration 0.5s ease-in-out infinite"
              }}
            >
              <img
                src={logo}
                alt="SignalR Logo"
                style={{
                  width: "90px",
                  height: "90px",
                  objectFit: "",
                  borderRadius: "50%",
                  filter: "drop-shadow(0 0 10px rgba(59, 130, 246, 0.5))"
                }}
              />
            </div>

            {/* Líneas conectivas */}
            {integrations.map((item, index) => {
              const angle = (index / integrations.length) * 2 * Math.PI;
              const radiusX = 230;
              const radiusY = 120;
              const centerX = 50;
              const centerY = 50;
              const x = centerX + (radiusX / 6) * Math.cos(angle);
              const y = centerY + (radiusY / 3.5) * Math.sin(angle);

              return (
                <div key={`line-${item.id}`}>
                  {/* Línea base */}
                  <div
                    className="position-absolute"
                    style={{
                      left: "50%",
                      top: "50%",
                      width: `${Math.sqrt(Math.pow((x - centerX) * 6, 2) + Math.pow((y - centerY) * 3.5, 2))}%`,
                      height: "2px",
                      background: "linear-gradient(90deg, rgba(59, 130, 246, 0.4), rgba(59, 130, 246, 0.1))",
                      transformOrigin: "0 50%",
                      transform: `rotate(${Math.atan2((y - centerY) * 3.5, (x - centerX) * 6) * 180 / Math.PI}deg)`,
                      zIndex: 1,
                    }}
                  />
                  
                  {/* Punto móvil */}
                  <div
                    className="position-absolute moving-dot"
                    style={{
                      left: "50%",
                      top: "50%",
                      width: "8px",
                      height: "8px",
                      background: "radial-gradient(circle, #3b82f6, #1d4ed8)",
                      borderRadius: "50%",
                      transformOrigin: "0 50%",
                      transform: `rotate(${Math.atan2((y - centerY) * 3.5, (x - centerX) * 6) * 180 / Math.PI}deg)`,
                      zIndex: 2,
                      boxShadow: "0 0 10px rgba(59, 130, 246, 0.8), 0 0 20px rgba(59, 130, 246, 0.4)",
                      animation: `move-dot-${index} 3s linear infinite`
                    }}
                  />
                </div>
              );
            })}

            {/* Íconos distribuidos en elipse */}
            {integrations.map((item, index) => {
              const angle = (index / integrations.length) * 2 * Math.PI;
              const radiusX = 230; // extensión horizontal
              const radiusY = 120; // extensión vertical
              const centerX = 50; // porcentaje del centro
              const centerY = 50; // porcentaje del centro
              const x = centerX + (radiusX / 6) * Math.cos(angle); // ajustado para porcentaje
              const y = centerY + (radiusY / 3.5) * Math.sin(angle); // ajustado para porcentaje

              return (
                <div
                  key={item.id}
                  className="position-absolute d-flex justify-content-center align-items-center rounded-circle bg-white shadow-sm integration-icon"
                  style={{
                    width: "75px",
                    height: "75px",
                    left: `${x}%`,
                    top: `${y}%`,
                    transform: "translate(-50%, -50%)",
                    border: "1px solid #e0e0e0",
                    zIndex: 2,
                  }}
                >
                  <img
                    src={item.img}
                    alt={item.alt}
                    title={item.alt}
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div
                    className="d-none justify-content-center align-items-center fw-bold text-white"
                    style={{
                      width: "35px",
                      height: "35px",
                      fontSize: "10px",
                      textAlign: "center",
                      background: item.color,
                      borderRadius: "50%",
                    }}
                  >
                    {item.name}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      
      <style>{`
        @keyframes pulse-glow {
          0% {
            box-shadow: 0 0 20px rgba(59, 130, 246, 0.6), 0 0 40px rgba(59, 130, 246, 0.4), 0 0 60px rgba(59, 130, 246, 0.2);
          }
          100% {
            box-shadow: 0 0 30px rgba(59, 130, 246, 0.8), 0 0 50px rgba(59, 130, 246, 0.6), 0 0 80px rgba(59, 130, 246, 0.4);
          }
        }
        
        @keyframes vibration {
          0%, 100% { transform: translate(-50%, -50%) translate(0, 0); }
          25% { transform: translate(-50%, -50%) translate(1px, -1px); }
          50% { transform: translate(-50%, -50%) translate(-1px, 1px); }
          75% { transform: translate(-50%, -50%) translate(1px, 1px); }
        }
        
        @keyframes move-dot-0 {
          0% { transform: rotate(0deg) translateX(0%); }
          100% { transform: rotate(0deg) translateX(100%); }
        }
        
        @keyframes move-dot-1 {
          0% { transform: rotate(45deg) translateX(0%); }
          100% { transform: rotate(45deg) translateX(100%); }
        }
        
        @keyframes move-dot-2 {
          0% { transform: rotate(90deg) translateX(0%); }
          100% { transform: rotate(90deg) translateX(100%); }
        }
        
        @keyframes move-dot-3 {
          0% { transform: rotate(135deg) translateX(0%); }
          100% { transform: rotate(135deg) translateX(100%); }
        }
        
        @keyframes move-dot-4 {
          0% { transform: rotate(180deg) translateX(0%); }
          100% { transform: rotate(180deg) translateX(100%); }
        }
        
        @keyframes move-dot-5 {
          0% { transform: rotate(225deg) translateX(0%); }
          100% { transform: rotate(225deg) translateX(100%); }
        }
        
        @keyframes move-dot-6 {
          0% { transform: rotate(270deg) translateX(0%); }
          100% { transform: rotate(270deg) translateX(100%); }
        }
        
        @media (max-width: 768px) {
          .integration-container {
            width: 100% !important;
            max-width: 500px !important;
            height: 300px !important;
          }
          
          .integration-icon {
            width: 60px !important;
            height: 60px !important;
          }
          
          .integration-icon img {
            width: 25px !important;
            height: 25px !important;
          }
          
          .central-icon {
            width: 80px !important;
            height: 80px !important;
          }
          
          .central-icon img {
            width: 50px !important;
            height: 50px !important;
          }
        }
        
        @media (max-width: 480px) {
          .integration-container {
            height: 250px !important;
          }
          
          .integration-icon {
            width: 50px !important;
            height: 50px !important;
          }
          
          .central-icon {
            width: 70px !important;
            height: 70px !important;
          }
          
          .central-icon img {
            width: 40px !important;
            height: 40px !important;
          }
        }
      `}</style>
    </>
    // <div
    //   className="d-flex flex-column justify-content-center align-items-center min-vh-100 rounded-3 shadow-lg p-5 rounded-4"
    //   style={{
    //     background: "linear-gradient(120deg, #2757811f, #00f1fe27, #1088ce21, #0c21db25, #11196121)",
    //     backgroundSize: "400% 400%",
    //     animation: "gradientBG 15s ease infinite",
    //   }}
    // >
    //   <div className="text-center mb-4">
    //     <h1 className="fw-bold display-4">¿Qué quieres construir?</h1>
    //     <p className="lead opacity-75">
    //       Impulsar, ejecutar e implementar conversaciones de IA
    //     </p>
    //   </div>

    //   <div className="w-100" style={{ maxWidth: "700px" }}>
    //     <div className="rounded-3 shadow-lg p-3 rounded-4">
    //       <textarea
    //         className="form-control border-0 rounded-4"
    //         rows="3"
    //         placeholder="¿Cómo puede SignalGPT ayudarte hoy?"
    //         style={{ resize: "none", outline: "none" }}
    //       ></textarea>
    //     </div>
    //   </div>

    //   <div className="d-flex flex-wrap justify-content-center gap-2 mt-4">
    //     <button className="btn btn-outline-secondary rounded-pill">
    //       Ventas del mes
    //     </button>
    //     <button className="btn btn-outline-secondary rounded-pill">
    //       Producto mas vendido
    //     </button>
    //     <button className="btn btn-outline-secondary rounded-pill">
    //       Usuario con mas ventas
    //     </button>
    //   </div>

    //   <style>{`
    //     @keyframes gradientBG {
    //       0% { background-position: 0% 50%; }
    //       50% { background-position: 100% 50%; }
    //       100% { background-position: 0% 50%; }
    //     }
    //   `}</style>
    // </div>
  );
}
